import React from 'react';
import { Icon, Tooltip, message } from 'antd';
import { removeFileExtensions } from '../../../utils/removeFileExtensions';
import styles from '../IconBlock.module.scss';

const PdfIcon = ({ attachment, getAttachmentUrl }) => {
  const handlePDFPreview = async () => {
    const url = await getAttachmentUrl(attachment.fileName || attachment);

    if (!url) {
      message.error('Не удалось открыть файл');
      return;
    }

    const w = window.open(url, '_blank');

    if (w) {
      const attachName = removeFileExtensions(attachment.name);

      setTimeout(() => {
        w.document.title = attachName;
      }, 500);
    }
  };

  return (
    <Tooltip title="Просмотр">
      <Icon
        type="file-pdf"
        onClick={handlePDFPreview}
        className={styles.icon}
        style={{ cursor: 'pointer' }}
      />
    </Tooltip>
  );
};

export default PdfIcon;
